import React, {FC, Fragment} from 'react';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import WrapperPreloader from '../../components/WrapperPreloader';
import BrandsTobaccoPage from "./BrandsTobaccoPage";
import TastesTobaccoPage from "./TastesTobaccoPage";

interface IInitialPreferences {
    getTobaccoInformation: any,
    isLoading: boolean
}

const InitialPreferences: FC<IInitialPreferences> = ({isLoading}) => {
    return (
        <WrapperPreloader isLoading={isLoading}>
            <Fragment>
                <Route
                    component={TastesTobaccoPage}
                    path="/start/tastes"
                />
                <Route
                    component={BrandsTobaccoPage}
                    path="/start/brands"
                />
            </Fragment>
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    isLoading: state.system.isLoading,
});

export default connect(
    mapStateToProps,
    null,
)(InitialPreferences);
